<template>
  <div>
    <div :class="[$style.printHeader]">
      <AppButton
        content="このページを印刷する"
        :class="[$style.printHeaderButton]"
        @click="clickPrintHandler"
      />
    </div>

    <slot />
  </div>
</template>

<script lang="ts">
export default {
  methods: {
    clickPrintHandler(): void {
      window.print()
    }
  }
}
</script>

<style module lang="postcss">
.printHeader {
  position: sticky;
  top: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: var(--color-white);
  border-bottom: 1px solid var(--color-k20);
}

@media print {
  .printHeader {
    display: none;
  }
}
</style>
